import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';

/** Per tag slug: undefined = not loaded, null = loading, {facts, rank} once loaded */
const cache = {};

/** The tag's facts and (for states) its ranking, fetched once and shared by the header pieces */
export function tagFacts(slug) {
  if (cache[slug] === undefined) {
    cache[slug] = null;
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/datahub/tag-facts/' + encodeURIComponent(slug),
      errorHandler: () => {}
    }).then(r => {
      cache[slug] = {
        facts: r && r.facts || [],
        rank: r && r.rank || null
      };
      m.redraw();
    }).catch(() => {
      cache[slug] = {
        facts: [],
        rank: null
      };
    });
  }
  return cache[slug];
}
const go = (e, href) => {
  if (!e.ctrlKey && !e.metaKey && href.startsWith('/')) {
    e.preventDefault();
    m.route.set(href);
  }
};

/** A state's rank as a small link, shown right beside the tag name */
export function rankLink(rank) {
  if (!rank) return null;
  return m("a", {
    className: "DHTagRank",
    href: rank.href,
    title: 'Ranked ' + rank.rank + ' of ' + rank.of + ' states by ' + rank.by,
    onclick: e => go(e, rank.href)
  }, "#", rank.rank);
}

/**
 * Key facts in a location tag's header (from the Data Hub): Nigerians living there, inflation and
 * exchange rate for diaspora countries and their cities; population, IGR and FAAC for states.
 */
export default class TagFacts extends Component {
  view() {
    const data = tagFacts(this.attrs.slug);
    const facts = data && data.facts;
    if (!facts || !facts.length) return null;
    return m("div", {
      className: "DHTagFacts"
    }, facts.map(f => m("a", {
      className: "DHTagFacts-fact",
      href: f.href,
      title: 'Source: Voucha Data Hub' + (f.period ? ' (' + f.period + ')' : ''),
      onclick: e => go(e, f.href)
    }, f.icon ? m("i", {
      className: f.icon,
      "aria-hidden": "true"
    }) : null, f.icon ? ' ' : '', f.label, f.label.endsWith('=') ? ' ' : ': ', m("strong", null, f.value), f.period ? m("span", {
      className: "DHTagFacts-period"
    }, " (", f.period, ")") : null)));
  }
}